var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 3.33332H5.66666C4.26653 3.33332 3.56646 3.33332 3.03168 3.6058C2.56128 3.84549 2.17882 4.22794 1.93914 4.69834C1.66666 5.23312 1.66666 5.93319 1.66666 7.33332V14.3333C1.66666 15.7335 1.66666 16.4335 1.93914 16.9683C2.17882 17.4387 2.56128 17.8212 3.03168 18.0608C3.56646 18.3333 4.26653 18.3333 5.66666 18.3333H12.6667C14.0668 18.3333 14.7669 18.3333 15.3016 18.0608C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6667 16.4335 16.6667 15.7335 16.6667 14.3333V10.8333M6.66663 13.3333H8.06209C8.46974 13.3333 8.67356 13.3333 8.86538 13.2873C9.03544 13.2464 9.19801 13.1791 9.34713 13.0877C9.51533 12.9847 9.65945 12.8405 9.9477 12.5523L17.9167 4.58332C18.607 3.89296 18.607 2.77368 17.9167 2.08332C17.2263 1.39296 16.107 1.39296 15.4167 2.08332L7.44769 10.0523C7.15943 10.3405 7.0153 10.4847 6.91223 10.6528C6.82085 10.802 6.75351 10.9645 6.71268 11.1346C6.66663 11.3264 6.66663 11.5302 6.66663 11.9379V13.3333Z",
    stroke: "#667085",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "7f7a3b144cca64fefd986c891537b517.svg";
export { ForwardRef as ReactComponent };